import cloudFunctionsUrl from "../config/cloudFunctionsEndpoint"
import axios from "axios"

function toSnakeCase(name) {
  return name
    .replace(/([A-Z]+)([A-Z][a-z])/g, "$1_$2")
    .replace(/([a-z0-9])([A-Z])/g, "$1_$2")
    .toLowerCase()
}

function isLocalEndpoint(url) {
  if (typeof url !== "string" || !url.trim()) {
    return false
  }

  const normalizedUrl = /^[a-z][a-z\d+.-]*:\/\//i.test(url)
    ? url
    : `http://${url}`

  try {
    const { hostname } = new URL(normalizedUrl)
    return /^(localhost|127\.0\.0\.1)$/i.test(hostname)
  } catch {
    return false
  }
}

async function postWithLocalFallback(
  baseUrl,
  functionName,
  payload,
  requestConfig,
) {
  const fallbackName = toSnakeCase(functionName)
  const isLocal = isLocalEndpoint(baseUrl)

  const primaryName = isLocal ? fallbackName : functionName
  const retryName = isLocal ? functionName : fallbackName

  const primaryUrl = `${baseUrl}/${primaryName}`
  const retryUrl = `${baseUrl}/${retryName}`

  try {
    return await axios.post(primaryUrl, payload, requestConfig)
  } catch (error) {
    const shouldRetry =
      isLocal &&
      error?.response?.status === 404 &&
      retryName !== primaryName
      
    if (!shouldRetry) {
      throw error
    }

    return await axios.post(retryUrl, payload, requestConfig)
  }
}

export async function callCloudFunctionNoAuth(functionName, payload) {
  return await postWithLocalFallback(cloudFunctionsUrl(), functionName, payload)
}

export async function callCloudFunction(functionName, payload, jwt) {
  const requestConfig = {
    headers: {
      Authorization: `Bearer ${jwt}`,
      "Content-Type": "application/json",
    },
  }

  return await postWithLocalFallback(
    cloudFunctionsUrl(),
    functionName,
    payload,
    requestConfig,
  )
}
